import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";

/**
 * QuestionCheckbox component for rendering a checkbox with a label.
 *
 * @param {object} props - Component props.
 * @param {string} props.label - The label text for the checkbox.
 * @param {boolean} props.disabled - Indicates whether the checkbox is disabled.
 * @param {boolean} props.checked - Indicates whether the checkbox is checked.
 * @param {function} props.onChange - Event handler for when the checkbox state changes.
 * @returns {JSX.Element} - React JSX element representing the checkbox with a label.
 */
export const QuestionCheckbox = (props: any) => {
	return (
		<FormControlLabel
			control={
				<Checkbox
					sx={{
						color: "#474848",
						"&.Mui-checked": {
							color: "#474848",
						},
						"&.Mui-disabled": {
							color: "rgba(182, 182, 182, 1)",
							pointerEvents: "auto",
							"&:hover": {
								backgroundColor: "transparent",
							},
							cursor: "not-allowed",
							"& .MuiSvgIcon-root .innerBox": {
								fill: "#eee",
							},
						},
					}}
					disabled={props.disabled}
					checked={props.checked}
					onChange={props.onChange}
				/>
			}
			label={props.label}
			sx={{ "& .MuiTypography-root": { fontSize: "14px" } }}
		/>
	);
};
